export enum CabinProductClass {
  ECONOMY_LIGHT = 'EL',
  ECONOMY_CLASSIC = 'EC',
  ECONOMY_PLUS = 'EP',
  PREMIUM_LIGHT = 'PL',
  PREMIUM_CLASSIC = 'PC',
  PREMIUM_PLUS = 'PP',
}

export enum ExtrasBundle {
  ECONOMY_LIGHT_WITH_EXTRAS_BUNDLE = 'ELTS',
  ECONOMY_CLASSIC_WITH_EXTRAS_BUNDLE = 'ECTS',
}

export const CabinClassWithExtrasBundle = {
  EL: ExtrasBundle.ECONOMY_LIGHT_WITH_EXTRAS_BUNDLE,
  EC: ExtrasBundle.ECONOMY_CLASSIC_WITH_EXTRAS_BUNDLE,
} as const;


export const CabinClassWithoutExtrasBundle = {
  ELTS: CabinProductClass.ECONOMY_LIGHT,
  ECTS: CabinProductClass.ECONOMY_CLASSIC,
} as const;


export enum CabinClassCode {
  ECONOMY = 'E',
  PREMIUM = 'P',
}

export enum BundleClassCode {
  LIGHT = 'L',
  CLASSIC = 'C',
  PLUS = 'P',
}

export enum CabinClassCodeToName {
  E = 'Economy',
  P = 'Premium',
}

export enum BundleClassCodeToName {
  L = 'Light',
  C = 'Classic',
  P = 'Flextra',
}
